// src/components/TaskModal/ConfirmDialog.jsx
// Placeholder — confirm logic is handled inline in TaskModal via deleteTask dispatch.
// This component can be wired up for a separate confirmation flow if needed.
export default function ConfirmDialog() {
  return null;
}
